import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import '@careerforge/ui/style.css'
import '#cf-theme'

createApp(App).use(createPinia()).use(router).mount('#app')
